import { defineMessages } from 'react-intl';

export default defineMessages({
  amountTitle: 'Available to repay',
  formDescription: 'How much do you want to repay?',

  error: 'Incorrect connection to HOC',

  warningText:
    'Before repaying {symbol} please check the amount you want to repay is not used for staking. If it is used for staking, your transaction might fail.',
});
